import type { FC, PropsWithChildren } from "react";
import * as s from "./MiniCard.module.scss";

type MiniCardProps = PropsWithChildren<{
	productName: string;
	fabric?: string | null;
	color: string;
}>;

const MiniCard: FC<MiniCardProps> = ({
	children,
	productName,
	fabric,
	color,
}) => {
	return (
		<section className={s.container}>
			<div className={s.image}>{children}</div>
			<div className={s.content}>
				<h5>{productName}</h5>
				<p className={s.info}>{[fabric, color].filter(Boolean).join(", ")}</p>
			</div>
		</section>
	);
};

export default MiniCard;
